import { Link } from "react-router-dom";
import styles from "./BlogPreview.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import useBlogPosts from "../hooks/useBlogPosts";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

/** Hidden entirely until published posts exist. */
export default function BlogPreview({ limit = 3 }) {
  const { posts, hasPosts } = useBlogPosts();

  if (!hasPosts) return null;

  const shown = posts.slice(0, limit);

  return (
    <section className={`u-section ${styles.section}`}>
      <div className="u-shell">
        <Reveal className={styles.head}>
          <div>
            <p className="u-eyebrow">Health insights</p>
            <h2 className={styles.heading}>Recent articles.</h2>
          </div>
          <Link to="/blog" className={styles.all}>
            All articles
            <Icon name="arrow" size={16} />
          </Link>
        </Reveal>

        <ul className={styles.grid}>
          {shown.map((post, i) => (
            <Reveal as="li" key={post.id} delay={i * 70} className={styles.cell}>
              <Link to={`/blog/${post.id}`} className={styles.card}>
                <time className={styles.date} dateTime={post.date}>
                  {formatDate(post.date)}
                </time>
                <h3 className={styles.title}>{post.title}</h3>
                <p className={styles.excerpt}>{post.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
